import script from "./KeepButton.vue?vue&type=script&setup=true&lang=js"
export * from "./KeepButton.vue?vue&type=script&setup=true&lang=js"

import "./KeepButton.vue?vue&type=style&index=0&id=378c1389&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-378c1389"]])

export default __exports__